import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

import Star from '../../../../svg/star_sm.svg';
import Arrow from '../../../../svg/arr_right_top.svg';
import ArrowLeft from '../../../../svg/arr_left_top.svg';

const SubNavigation = ({ dataSubNav, show, closeSubMenu, activeHeader }) => {
  const langToggle = useLanguage;
  // const height = activeHeader ? '80px' : ' ';

  return (
    <div
      className={!show ? 'submenu-wrapper' : 'submenu-wrapper is-show'}
      style={{ top: activeHeader ? '80px' : ' ' }}
    >
      <div className="page-wrapper__overflow">
        <button className="submenu-close" onClick={closeSubMenu}>
          <span className="submenu-close__icon">
            <Star className="submenu-close__icon-star" />
            <ArrowLeft className="submenu-close__icon-arrow" />
          </span>
          <span className="submenu-close__title">
            {langToggle('В головне меню', 'В главное меню')}
          </span>
        </button>
        <ul className="submenu">
          {dataSubNav.Services.map((item, index) => {
            const counter = ++index;
            return (
              <li className="submenu-item" key={index}>
                <Link to={'/' + item.link} className="submenu-item__link">
                  <span className="item-link__top">
                    <span className="submenu-counter">
                      {counter <= 9 ? '0' + counter + '.' : counter + '.'}
                    </span>
                    <span className="submenu-icon">
                      <Star className="submenu-icon__star" />
                      <Arrow className="submenu-icon__arrow" />
                    </span>
                  </span>
                  <span className="item-link__title">
                    <span>
                    {langToggle(item.description_ua, item.description_ru)}
                    </span>  
                    {' '}
                    <span> 
                    {langToggle(item.title_ua, item.title_ru)}
                    </span>      
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

SubNavigation.propTypes = {
  dataSubNav: PropTypes.object,
  show: PropTypes.bool,
  closeSubMenu: PropTypes.func,
};

export default SubNavigation;
